import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { ClinicalNoteApi } from '../../../apis/ClinicalNoteApi/ClinicalNoteApi';
import { ClinicalNoteData, ClinicalNoteType } from '../ClinicalNote';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute';

export function useClinicalNotes(noteType: ClinicalNoteType, id?: string) {
    const patientId = id || useIdFromRoute();
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.clinicalNotes, noteType, patientId],
        queryFn: async () => {
            const result: ClinicalNoteData = await ClinicalNoteApi.getClinicalNotes(patientId!, noteType);
            return new ClinicalNoteData(result);
        },
        enabled: !!patientId,
    });
}
